import { AssetButtonGroup } from "@/shared/selectors/AssetButtonGroup";
import type { AreaIds } from "@/pages/workOrders/config/assetFieldConfig";
import { Button, ButtonGroup, Grid2, Paper, Typography } from "@mui/material";

const MONTH_LABELS = [
	"January",
	"February",
	"March",
	"April",
	"May",
	"June",
	"July",
	"August",
	"September",
	"October",
	"November",
	"December",
];

const PAPER_SX = { padding: 2, height: "100%", display: "flex" } as const;
const NAV_BUTTON_SX = { textTransform: "none", px: 3 } as const;

type Props = {
	currentDate: Date;
	assetName: string | null;
	areaIds: AreaIds;
	onMonthOffset: (offset: number) => void;
	onToday: () => void;
	onAssetChange: (assetName: string | null, assetId: number | null) => void;
};

export const CalendarToolbar = ({
	currentDate,
	assetName,
	areaIds,
	onMonthOffset,
	onToday,
	onAssetChange,
}: Props) => {
	const now = new Date();
	const isCurrentMonth =
		currentDate.getMonth() === now.getMonth() &&
		currentDate.getFullYear() === now.getFullYear();

	return (
		<>
			<Grid2 size="auto">
				<Paper
					elevation={1}
					sx={{
						...PAPER_SX,
						flexDirection: "column",
						alignItems: "flex-start",
						gap: 1,
					}}
				>
					<Typography variant="h5" sx={{ fontWeight: 700 }}>
						{MONTH_LABELS[currentDate.getMonth()]} {currentDate.getFullYear()}
					</Typography>
					<ButtonGroup color="primary">
						<Button onClick={() => onMonthOffset(-1)} sx={NAV_BUTTON_SX}>
							Previous
						</Button>
						<Button
							variant={isCurrentMonth ? "contained" : "outlined"}
							onClick={onToday}
							sx={NAV_BUTTON_SX}
						>
							Today
						</Button>
						<Button onClick={() => onMonthOffset(1)} sx={NAV_BUTTON_SX}>
							Next
						</Button>
					</ButtonGroup>
				</Paper>
			</Grid2>

			<Grid2 size="grow">
				<Paper elevation={1} sx={{ ...PAPER_SX, alignItems: "center" }}>
					<AssetButtonGroup
						value={assetName}
						onChange={onAssetChange}
						areaIds={areaIds}
					/>
				</Paper>
			</Grid2>
		</>
	);
};
